export default __webpack_public_path__ + "static/media/cover (7).8a70c7a0.svg";